var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "coupon" }, [
    _c("h4", [_vm._v("Saldo bônus disponível")]),
    _vm._v(" "),
    _c("p", [
      _vm._v("Esse saldo não pode ser utilizado com outros saldos ou cupom.")
    ]),
    _vm._v(" "),
    _c("div", [
      _c("label", { staticClass: "checkbox" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.useAccountBonus,
              expression: "useAccountBonus"
            }
          ],
          staticClass: "save-checbox",
          attrs: {
            error: _vm.errors.first("store"),
            name: "save-checkbox",
            type: "checkbox",
            disabled: _vm.accountBalance || !_vm.canPayWithAccountBonus
          },
          domProps: {
            checked: Array.isArray(_vm.useAccountBonus)
              ? _vm._i(_vm.useAccountBonus, null) > -1
              : _vm.useAccountBonus
          },
          on: {
            change: [
              function($event) {
                var $$a = _vm.useAccountBonus,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.useAccountBonus = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.useAccountBonus = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.useAccountBonus = $$c
                }
              },
              function($event) {
                _vm.setAccountBonus()
              }
            ]
          }
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Selecione essa opção se deseja utilizar esse saldo bônus para abater parte do valor da limpeza."
          )
        ])
      ]),
      _vm._v(" "),
      _c("p"),
      _vm._v(" "),
      _c("div", { staticClass: "amount" }, [
        _vm._v(
          _vm._s(
            _vm._f("toCurrency")(_vm.user.payment_gateway_account.wallet.bonus)
          )
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ada87730", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ada87730","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/Payable/OrderComponents/AccountBonus.vue
// module id = null
// module chunks = 